export * from './users.constants';
export * from './regular-expressions.constants';
export * from './time';
export * from './events.constants';
export * from './analytics.constants';
export * from './image.constants';
export * from './notifications.constants';
export * from './facebook-pixel.constants';
export * from './blast-plan.constants';
export * from './time-zones-locales.constants';

export const ALLOWED_CHANNEL_AVATAR_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
export const ALLOWED_USER_AVATAR_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/webp'];
export const ALLOWED_USER_BG_IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/webp'];
export const ALLOWED_PAST_EVENT_IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
export const ALLOWED_PAST_EVENT_VIDEO_MIME_TYPES = ['video/mp4', 'video/quicktime'];
export const ALLOWED_SWEAT_MATCH_IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/webp'];
export const ALLOWED_SWEAT_MATCH_VIDEO_MIME_TYPES = ['video/mp4', 'video/quicktime'];
export const ALLOWED_INTEREST_ICON_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
export const ALLOWED_EVENT_AVATAR_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/webp'];
export const ALLOWED_CHAT_MESSAGE_PICTURE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
export const ALLOWED_CHAT_MESSAGE_VIDEO_MIME_TYPES = ['video/mp4', 'video/quicktime'];

export const groupChatAutoGenerateCommand = 'group:auto-generated';

export const DEFAULT_CURRENCY = 'usd';
export const DEFAULT_TIME_ZONE = 'US/Central';
export const PROJECT_PART_HEADER = 'X-Project-Part';
export const PROJECT_CLIENT_VERSION_HEADER = 'X-Client-Version';

export const PROJECT_PART_HEADER_VALUES = {
	WEBAPP: 'webapp',
	ADMIN_PANEL: 'admin_panel',
	MOBILE: 'mobile',
	LANDING: 'landing'
};

export const SUPPORT_EMAIL = 'support@sweatpals.com';
